// extracted by mini-css-extract-plugin
export default {"mediaData":"mediaData_mediaData__NW-Ff","title":"mediaData_title__0+epF","mediaDataWrap":"mediaData_mediaDataWrap__1UlRv"};